import * as XLSX from 'xlsx';

// Download student data as Excel file

export const downloadExcelFile = (allData, selectedColumns, columnLabels = {}) => {
  try {
    if (!Array.isArray(allData) || allData.length === 0) {
      alert("No data available to download");
      return;
    }

    console.log(`Downloading ${allData.length} records`);

    // Use selectedColumns if provided, otherwise use all columns from first record
    const columnsToExport = selectedColumns && selectedColumns.length > 0 
      ? selectedColumns 
      : Object.keys(allData[0]);

    // Map each row, including only selected columns
    const filteredData = allData.map(item => {
      const filteredItem = {};
      columnsToExport.forEach(column => {
        filteredItem[column] = item[column] ?? ""; // null/undefined fallback to ""
      });
      return filteredItem;
    });

    // Prepare headers: map internal keys to readable column labels
    const headers = columnsToExport.map(col => columnLabels[col] || col);

    // Generate worksheet
    const ws = XLSX.utils.json_to_sheet(filteredData, { header: columnsToExport });

    // Inject header labels at the top
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });

    // Create workbook and append the sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Student Records");

    // Format the filename
    const currentDate = new Date().toISOString().split('T')[0];
    const fileName = `Student_Records_${currentDate}.xlsx`;

    // Trigger download
    XLSX.writeFile(wb, fileName);
  } catch (error) {
    console.error("Error downloading Excel:", error);
    alert("Failed to download data. Please try again.");
  }
};



export const columnLabels = {
  studentId: "Student ID",
  name: "Full Name",
  contact: "Contact Number",
  email: "Email",
  course: "Course Enrolled",
  branch: "Branch",
  // Add other fields based on your data structure
};
